import api from 'Application/api/api';

const getActivityById = (signal, id) =>
	api.get(`/activity-templates/${id}?details=true`, {
		signal,
	});

export default getActivityById;
